const publicUrl = process.env.PUBLIC_URL || '';

export const Routes = {
  GrapeCityHomePage: 'https://developer.mescius.com',
  ActiveReportsHomePage: 'https://developer.mescius.com/activereportsnet',
  ActiveReportsDownload: 'https://developer.mescius.com/activereportsnet/download',
  PageNotFound: `${publicUrl}/404`,
  Reports: `${publicUrl}/`,
  Docs: 'https://developer.mescius.com/activereportsnet/docs/latest/online/overview.html',
  ThemeEditor: `${publicUrl}/theme-editor`,
};
